import { c as _c } from "react/compiler-runtime";
import React, { useContext, useEffect, useRef, useState } from "react";
import { GoogleAnalytics } from "../GoogleAnalytics";
import { GoogleTagManager } from "../GoogleTagManager";
import styles from "./CookieBanner.module.scss";
import { LinkComponent } from "../../../main/blocks/Links/Links";
import { HotJar } from "../HotJar";
import { ConsentState } from "../../../../middleware.page";
import { setCookie } from "cookies-next/client";
import { BannerContext } from "../../../main/layout/layout";
import { MetaPixel } from "../MetaPixel";
import { CookieBannerQueryResult } from "../../../../studio/sanity.types";
export const CookieBanner: React.FC<{
  configuration: CookieBannerQueryResult;
}> = t0 => {
  const $ = _c(28);
  const {
    configuration
  } = t0;
  const [bannerContext, setBannerContext] = useContext(BannerContext);
  const [tracking, setTracking] = useState(false);
  const bannerRef = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (typeof window !== "undefined") {
        const ignore = localStorage.getItem("plausible_ignore");
        if (ignore === "true") {
          setTracking(false);
        } else {
          setTracking(true);
        }
      }
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const root = document.documentElement;
      const element = bannerRef.current;
      if (!element) {
        root.style.setProperty("--cookie-banner-height", "0px");
        return;
      }
      const updateHeight = () => {
        root.style.setProperty("--cookie-banner-height", `${element.offsetHeight}px`);
      };
      updateHeight();
      const observer = new ResizeObserver(updateHeight);
      observer.observe(element);
      return () => {
        observer.disconnect();
        root.style.setProperty("--cookie-banner-height", "0px");
      };
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== bannerContext.consentState) {
    t4 = [bannerContext.consentState];
    $[3] = bannerContext.consentState;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  useEffect(t3, t4);
  if (!configuration) {
    return null;
  }
  const gaMeasurementId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;
  const gtmId = process.env.NEXT_PUBLIC_GTM_ID;
  const hotjarId = process.env.NEXT_PUBLIC_HOTJAR_ID;
  const metaPixelId = process.env.NEXT_PUBLIC_META_PIXEL_ID;
  const expiredTemplate = configuration.expired_template || "Last updated {date}";
  let t5;
  if ($[5] !== setBannerContext) {
    t5 = state => {
      setCookie("gieffektivt-cookies-accepted", state === "accepted" ? "true" : "false", {
        sameSite: "lax",
        expires: new Date(new Date().getTime() + 31536000000)
      });
      setBannerContext(prev => ({
        ...prev,
        consentState: state
      }));
    };
    $[5] = setBannerContext;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const setConsent = t5;
  let privacyPolicyLink = configuration.privacy_policy_link;
  if (bannerContext.consentExpired && bannerContext.privacyPolicyLastMajorChange && configuration.privacy_policy_link) {
    const t6 = configuration.privacy_policy_link;
    const t7 = configuration.privacy_policy_link.title;
    let t8;
    if ($[7] !== bannerContext.privacyPolicyLastMajorChange || $[8] !== expiredTemplate) {
      t8 = expiredTemplate.replace("{date}", bannerContext.privacyPolicyLastMajorChange.toLocaleDateString("no-NB"));
      $[7] = bannerContext.privacyPolicyLastMajorChange;
      $[8] = expiredTemplate;
      $[9] = t8;
    } else {
      t8 = $[9];
    }
    const t9 = `${t7} ${t8}`;
    let t10;
    if ($[10] !== configuration.privacy_policy_link || $[11] !== t9) {
      t10 = {
        ...t6,
        title: t9
      };
      $[10] = configuration.privacy_policy_link;
      $[11] = t9;
      $[12] = t10;
    } else {
      t10 = $[12];
    }
    privacyPolicyLink = t10;
  }
  let t6;
  if ($[13] !== bannerContext.consentExpired || $[14] !== bannerContext.consentState || $[15] !== tracking) {
    t6 = bannerContext.consentState === "accepted" && !bannerContext.consentExpired && tracking && <>{gtmId ? <GoogleTagManager gtmId={gtmId} /> : null}{gaMeasurementId ? <GoogleAnalytics gaMeasurementId={gaMeasurementId} /> : null}{hotjarId ? <HotJar hotjarId={hotjarId} /> : null}{metaPixelId ? <MetaPixel pixelId={metaPixelId} /> : null}</>;
    $[13] = bannerContext.consentExpired;
    $[14] = bannerContext.consentState;
    $[15] = tracking;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== bannerContext.consentState || $[18] !== configuration.accept_button_text || $[19] !== configuration.decline_button_text || $[20] !== configuration.description || $[21] !== configuration.title || $[22] !== privacyPolicyLink || $[23] !== setConsent) {
    t7 = bannerContext.consentState === "undecided" && <div data-cy="cookiebanner-container" className={styles.container} ref={bannerRef}><div className={styles.content}><div className={styles.description}><span className={styles.title}>{configuration.title}</span><p>{configuration.description}</p></div><div className={styles.buttonsWrapper}>{privacyPolicyLink && <LinkComponent link={privacyPolicyLink} style={{
            border: "none"
          }} />}<div className={styles.buttons}><button data-cy="decline-cookies" onClick={() => {
              setConsent("rejected" as ConsentState);
            }} style={{
              marginRight: "2rem"
            }}>{configuration.decline_button_text}</button><button data-cy="accept-cookies" onClick={() => {
              setConsent("accepted" as ConsentState);
            }}>{configuration.accept_button_text}</button></div></div></div></div>;
    $[17] = bannerContext.consentState;
    $[18] = configuration.accept_button_text;
    $[19] = configuration.decline_button_text;
    $[20] = configuration.description;
    $[21] = configuration.title;
    $[22] = privacyPolicyLink;
    $[23] = setConsent;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== t6 || $[26] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
};